<section class="any-image-works section">
  <div class="any-image-works__inner">
    <div class="container">
      <h2 class="any-image-works__title title-dark">Any image works</h2>

      <p class="any-image-works__subtitle subheading-dark">
        Click any scene to open it in the full 3D editor.
      </p>

      <ul class="any-image-works__cards">
        @for (scene of scenes; track scene.title) {
          <li class="any-image-works__card">
            <div class="any-image-works__card-head">
              <div class="any-image-works__card-meta">
                <h3 class="any-image-works__card-title type-title-h8">{{ scene.title }}</h3>

                <p class="any-image-works__card-author type-caption-c2">by {{ scene.author }}</p>
              </div>
            </div>

            <div class="any-image-works__card-scene">
              <div class="any-image-works__card-button">
                <app-button variant="secondary" [href]="scene.link">
                  Click to enter the scene
                </app-button>
              </div>

              <img
                class="any-image-works__card-image"
                fill
                [ngSrc]="scene.image"
                [alt]="scene.alt"
                draggable="false"
                loading="lazy"
              />

              <span class="any-image-works__card-overlay" aria-hidden="true"></span>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</section>
